(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2755],{

/***/ 83015:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/catalog/[...slug]",
      function () {
        return __webpack_require__(85541);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 85541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19453);
/* harmony import */ var _dy_commons_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76079);
/* harmony import */ var _dy_commons_utils__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_utils__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _dy_commons_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17566);
/* harmony import */ var _dy_commons_components__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_components__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _dy_commons_hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92757);
/* harmony import */ var _dy_commons_hooks__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_hooks__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73267);
/* harmony import */ var _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(83242);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  flex-grow: 2;\n  margin: 0 auto;\n  position: relative;\n\n  #main-top {\n    background-color: ",
        ";\n    display: block;\n    height: 2px;\n    opacity: .01;\n    position: absolute;\n    top: -25px;\n    user-select: none;\n    width: 100%;\n\n    ",
        " {\n      transform: translateY(-",
        ");\n    }\n\n    ",
        " {\n      transform: translateY(-20px);\n    }\n  }\n\n  ",
        " {\n    margin: 0 calc((100% - 1650px) / 2);\n    max-width: 1650px;\n  }\n\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}










// function categoryPath(category, locale, paths) {
//   const lang = locale.split('-')[0]
//   const params = { slug: category.slug[lang].split('/') }
//   const path = { params, locale }
//   paths.push(path)
//   if(Array.isArray(category?.subcategories)) {
//     for (const subcategory of category.subcategories) {
//       if (subcategory.slug[lang]) paths = categoryPath(subcategory, locale, paths)
//     }
//   }
//   return paths
// }
// function categoriesPaths(categories, lang) {
//   let paths = []
//   for(const category of categories) {
//     if (category?.slug[lang]) paths = categoryPath(category, lang, paths)
//   }
//   return paths
// }
// export async function getStaticPaths() {
//   const locale = NEXT_PUBLIC_LOCALE
//   if (locale === 'en-EU') return { paths: [], fallback: 'blocking' }
//   const apolloClient = initializeApollo()
//   const { data:resData } = await apolloClient.query({
//     query: GET_CATEGORIES,
//     variables: {
//       type: CATEGORIES.PRODUCT
//     }
//   })
//   const paths = resData ? categoriesPaths(resData.categories, locale) : []
//   return { paths, fallback: 'blocking' }
// }
var getSlug = function(slug) {
    return typeof slug === "string" ? slug : slug.join("/");
};
var updateQueryParams = function(param) {
    var query = param.query, activeFilters = param.activeFilters, push = param.push;
    var slug = getSlug(query.slug);
    var stringParams = (0,_dy_commons_utils__WEBPACK_IMPORTED_MODULE_4__.generateQueryParams)(activeFilters).stringParams;
    push("/catalog/[...slug]", "/catalog/".concat(slug, "?").concat(stringParams), {
        shallow: true
    });
};
var firstLoad = true;
var CatalogPage = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(param) {
    var _data = param.data, data = _data === void 0 ? {
        variants: []
    } : _data, layout = param.layout;
    var ref;
    var ref1 = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)(), routerLocale = ref1.locale, asPath = ref1.asPath, query = ref1.query, push = ref1.push, isFallback = ref1.isFallback;
    var lang = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return routerLocale.split("-")[0];
    }, [
        routerLocale
    ]);
    var isMounted = (0,_dy_commons_hooks__WEBPACK_IMPORTED_MODULE_6__.useMount)();
    var variants = data.variants, seo = data.seo, slug = data.slug;
    var categories = layout.categories;
    var size = (0,_dy_commons_hooks__WEBPACK_IMPORTED_MODULE_6__.useDeviceType)().size;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        sort: {
            recommended: true
        }
    }), activeFilters = ref2[0], setActiveFilters = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), featuredFilters = ref3[0], setFeaturedFilters = ref3[1];
    var filters = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return (0,_dy_commons_utils__WEBPACK_IMPORTED_MODULE_4__.getFilters)(variants, lang, false);
    }, [
        variants,
        lang
    ]);
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        all: Array.from(variants),
        current: Array.from(variants)
    }), currentProducts = ref4[0], setCurrentProducts = ref4[1];
    var scrollState = (0,_dy_commons_hooks__WEBPACK_IMPORTED_MODULE_6__.useScrollTracker)(160);
    var isScrolling = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return scrollState !== "TOP";
    }, [
        scrollState
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (window.history.scrollRestoration !== "manual") {
            window.history.scrollRestoration = "manual";
        }
        return function() {
            window.history.scrollRestoration = "auto";
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        // @ts-ignore
        if (!firstLoad && (query === null || query === void 0 ? void 0 : query.slug)) {
            //appending gift card to avoid hydratation errors after first load
            setCurrentProducts({
                all: variants,
                current: (0,_dy_commons_utils__WEBPACK_IMPORTED_MODULE_4__.getFilteredProducts)(variants, activeFilters)
            });
            setFeaturedFilters((0,_dy_commons_utils__WEBPACK_IMPORTED_MODULE_4__.getFeaturedFilters)(activeFilters, filters === null || filters === void 0 ? void 0 : filters[0]));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isMounted,
        query.slug,
        size
    ]);
    // Note for this useEffect, initially was [isMounted, activeFilters] but
    // since when we update the query params in the next useEffect, this cause a query.slug update
    // (even if the slug remains the same)
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (isMounted) {
            if (firstLoad) {
                firstLoad = false;
            } else {
                updateQueryParams({
                    query: query,
                    activeFilters: activeFilters,
                    push: push
                });
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isMounted,
        activeFilters
    ]);
    // Get param filters from URL
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (filters) {
            var incomingActiveFiltersFromUrl = (0,_dy_commons_utils__WEBPACK_IMPORTED_MODULE_4__.getFiltersFromQuery)(asPath, filters[1]);
            //@ts-ignore
            setActiveFilters(incomingActiveFiltersFromUrl);
        }
    }, [
        filters,
        asPath
    ]);
    if (isFallback) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_dy_commons_components__WEBPACK_IMPORTED_MODULE_5__.HeadTag, {
                seo: seo,
                pageType: "products",
                slug: slug[lang],
                jsonld: {
                    data: data,
                    pageType: "products"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_8__.HeaderShop, {
                data: categories
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Main, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                        id: "main-top"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_8__.NavShop, {
                        categories: categories
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_8__.SectionFilters, {
                        isScrolling: isScrolling,
                        filters: filters === null || filters === void 0 ? void 0 : filters[0],
                        activeFilters: activeFilters,
                        setActiveFilters: setActiveFilters,
                        resultsLength: currentProducts === null || currentProducts === void 0 ? void 0 : (ref = currentProducts.current) === null || ref === void 0 ? void 0 : ref.length
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_8__.DynamicSectionFiltersFeatured, {
                        filters: featuredFilters
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_8__.SectionProductList, {
                        products: currentProducts.current
                    }, "list-products-".concat(asPath))
                ]
            })
        ]
    });
});
CatalogPage.Layout = _components__WEBPACK_IMPORTED_MODULE_8__.Layout;
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (CatalogPage);
var Main = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].main.withConfig({
    displayName: "[...slug]__Main",
    componentId: "sc-442e1cdc-0"
})(_templateObject(), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.designGrid)({
    withoutGutter: true
}), function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("tablet"), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.vw)(20, "desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("desktop"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_7__.mq.greaterThan("desktop-wide"));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(83015); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);